import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLoadingSpinner from '../../Refactor/Components/LoadingSpinner/PageLoadingSpinner';
import NavigationRoutes from '../NavigationRoutes';

const StandaloneHomePage = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const navigate = useNavigate();

    const handleLogin = async () => oktaAuth.signInWithRedirect();

    useEffect(() => {
        if (authState && !authState.isAuthenticated) {
            handleLogin();
        }

        if (authState && authState.isAuthenticated) {
            navigate(NavigationRoutes.Dashboard);
        }
    }, [authState, authState?.isAuthenticated, navigate]);

    return <PageLoadingSpinner />;
};

export default StandaloneHomePage;
